/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_Li2_BInputs */

const tr_mesafeli_s6_li2_b = /** @type {(inputs: Mesafeli_S6_Li2_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sayfasındaki İptal Et düğmesiyle veya`)
};

const en_mesafeli_s6_li2_b = /** @type {(inputs: Mesafeli_S6_Li2_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`page using the Cancel button, or by written notice to`)
};

const de_mesafeli_s6_li2_b = /** @type {(inputs: Mesafeli_S6_Li2_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mit der Schaltfläche Kündigen oder per schriftlicher Mitteilung an`)
};

const ru_mesafeli_s6_li2_b = /** @type {(inputs: Mesafeli_S6_Li2_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`кнопкой Отменить либо письменным уведомлением на адрес`)
};

/**
* | output |
* | --- |
* | "page using the Cancel button, or by written notice to" |
*
* @param {Mesafeli_S6_Li2_BInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_li2_b = /** @type {((inputs?: Mesafeli_S6_Li2_BInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_Li2_BInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_li2_b(inputs)
	if (locale === "de") return de_mesafeli_s6_li2_b(inputs)
	if (locale === "ru") return ru_mesafeli_s6_li2_b(inputs)
	return tr_mesafeli_s6_li2_b(inputs)
});